import en from './en';
import fr from './fr';
import he from './he';
import ru from './ru';
import ar from './ar';
import cn from './cn';
import ge from './ge';
import sp from './sp';
import ja from './ja';
import ko from './ko';
import it from './it';
import hu from './hu';

export default {
    en: {
        message: en
    },
    fr: {
        message: fr
    },
    he: {
        message: he
    },
    ru: {
        message: ru
    },
    ar: {
        message: ar
    },
    cn: {
        message: cn
    },
    ge: {
        message: ge
    },
    sp: {
        message: sp
    },
    ja: {
        message: ja
    },
    ko: {
        message: ko
    },
    it: {
        message: it
    },
    hu: {
        message: hu
    }
}